/*eslint-disable*/
import axios from 'axios';

export default {
    methods: {
        async getBase64ImageFromUrl (imageUrl) {
            let blob;
            await axios.get(imageUrl, { responseType:"blob" })
                .then(response => {
                    blob = response.data
                });
            return new Promise((resolve, reject) => {
                let reader  = new FileReader();
                reader.addEventListener("load", () => {
                    resolve(reader.result);
                }, false);
                reader.onerror = () => {
                    return reject(this);
                };
                reader.readAsDataURL(blob);
            })
        }
    }
}